export default {hotkeys:{'open-sftp-tab':['Ctrl-Shift-S']}};